// extracted by mini-css-extract-plugin
export default {"filter-search":"src-components-filter-panel-FilterSearch-index__filter-search--rkipD","filterSearch":"src-components-filter-panel-FilterSearch-index__filter-search--rkipD"};